import { render, staticRenderFns } from "./eyeHabit.vue?vue&type=template&id=0ec5c138&scoped=true&"
import script from "./eyeHabit.vue?vue&type=script&lang=js&"
export * from "./eyeHabit.vue?vue&type=script&lang=js&"
import style0 from "./eyeHabit.vue?vue&type=style&index=0&id=0ec5c138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec5c138",
  null
  
)

export default component.exports